import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Api from '../Auth/Api';
import { Toast, Modal, Form } from 'react-bootstrap';
import { decodeJWT } from '../Components/jwtUtils';
import perguntasReacao from '../data/avaliacaoReacao.json';

function QuestionarioReacao() {
    const { id } = useParams();
    const token = JSON.parse(localStorage.getItem("user_token"));
    const [dataPerguntas, setDataPerguntas] = useState([]);
    const [respostas, setRespostas] = useState({});
    const [toast, setToast] = useState({});
    const [showToast, setShowToast] = useState(false);
    const [enviarAvaliacao, setEnviarAvaliacao] = useState(false);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [comentarios, setComentarios] = useState("");
    const [infoModulo, setInfoModulo] = useState(null);
    const [carregando, setCarregando] = useState(true);
    const navigate = useNavigate();
    const nivel = decodeJWT(token).nivel;
    
    // Alternativas para todas as questões
    const alternativasReacao = [
        "1 - Insatisfatório", 
        "2 - Regular", 
        "3 - Satisfatório", 
        "4 - Muito Bom", 
        "5 - Excelente"
    ];

    useEffect(() => {
        async function fetchInfo() {
            try {
                // Carregar informações do módulo
                const response = await Api.get(`api/info-modulo/${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                
                if (response.data && response.data.length > 0) {
                    setInfoModulo(response.data[0]);
                }
                
                // Usar perguntas do arquivo JSON
                setDataPerguntas(perguntasReacao);
            } catch (error) {
                console.error(error.response?.data?.message || error.message);
            } finally {
                setCarregando(false);
            }
        }
        
        fetchInfo();
    }, [id, token]);

    const [indiceAtual, setIndiceAtual] = useState(0);
    const perguntaAtual = dataPerguntas[indiceAtual];

    function proximaPergunta() {
        if (!perguntaAtual) return;
        
        // Verificar se há resposta com base no tipo de pergunta
        if (perguntaAtual.tipo === 'escala' && !respostas[perguntaAtual.id]) {
            setToast({ header: 'Ops!', body: "Você precisa escolher uma resposta" });
            setShowToast(true);
            return;
        }
        
        if (perguntaAtual.tipo === 'sim_nao' && respostas[perguntaAtual.id] === undefined) {
            setToast({ header: 'Ops!', body: "Você precisa escolher uma resposta" });
            setShowToast(true);
            return;
        }
        
        if (indiceAtual < dataPerguntas.length - 1) {
            setIndiceAtual(indiceAtual + 1);
        } else {
            setShowConfirmationModal(true);
        }
    }

    function perguntaAnterior() {
        if (indiceAtual > 0) {
            setIndiceAtual(indiceAtual - 1);
        }
    }

    function handleSelecao(perguntaId, alternativaIndex) {
        setRespostas(prev => ({
            ...prev,
            [perguntaId]: alternativaIndex
        }));
    }

    function handleSimNao(perguntaId, valor) {
        setRespostas(prev => ({
            ...prev,
            [perguntaId]: valor
        }));
    }

    const confirmSubmit = async () => {
        if (!respostas || Object.keys(respostas).length < dataPerguntas.length) {
            setToast({ header: 'Atenção!', body: 'Você precisa responder todas as perguntas.' });
            setShowToast(true);
            setShowConfirmationModal(false);
            return;
        }

        setShowConfirmationModal(false);

        const formattedAnswers = {};

        for (let perguntaId in respostas) {
            const perguntaData = dataPerguntas.find(p => p.id.toString() === perguntaId.toString());
            if (perguntaData) {
                if (perguntaData.tipo === 'escala') {
                    formattedAnswers[perguntaId] = {
                        questao: perguntaData.questao,
                        resposta: alternativasReacao[respostas[perguntaId] - 1],
                        alternativa: respostas[perguntaId].toString()
                    };
                } else if (perguntaData.tipo === 'sim_nao') {
                    formattedAnswers[perguntaId] = {
                        questao: perguntaData.questao,
                        resposta: respostas[perguntaId] ? 'Sim' : 'Não',
                        alternativa: respostas[perguntaId] ? '1' : '0'
                    };
                }
            }
        }

        const data = {
            respostas: formattedAnswers,
            idModulo: id,
            comentarios: comentarios
        }

        try {
            const response = await Api.post(`/api/progresso-avaliacao-reacao/${id}`, data, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setToast({ header: 'Concluído!', body: response.data.message })
            setTimeout(() => {
                setEnviarAvaliacao(true)
            }, 1000);
        } catch (error) {
            setToast({ header: 'Ops!', body: error.response?.data?.message || "Erro ao enviar avaliação" })
            console.error("Erro ao enviar resposta:", error.response?.data?.message || error.message)
        }

        setShowToast(true)
    }
    
    // Componente de carregamento
    const LoadingScreen = () => (
        <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '50vh' }}>
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Carregando...</span>
            </div>
        </div>
    );

    if (carregando) {
        return <LoadingScreen />;
    }

    return (
        <>
            <Toast show={showToast} onClose={() => setShowToast(false)} delay={3000} autohide style={{ position: 'fixed', left: '95%', bottom: '10px', transform: 'translateX(-95%)', zIndex: 9999, padding: 0 }}>
                <Toast.Header className={toast.header === 'Ops!' || toast.header === 'Atenção!' ? 'bg-danger text-white' : 'bg-success text-white'}>
                    <strong className="me-auto">{toast.header}</strong>
                </Toast.Header>
                <Toast.Body>{toast.body}</Toast.Body>
            </Toast>

            <Modal show={showConfirmationModal} onHide={() => setShowConfirmationModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Finalizar Avaliação</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Comentários, sugestões e críticas:</p>
                    
                    <Form.Group className="mb-3">
                        <Form.Control 
                            as="textarea" 
                            rows={5} 
                            value={comentarios}
                            onChange={(e) => setComentarios(e.target.value)}
                            placeholder="Compartilhe sua opinião sobre o treinamento..."
                        />
                    </Form.Group>
                    
                    <p>Tem certeza que deseja enviar sua avaliação?</p>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center bg-light">
                    <button onClick={confirmSubmit} className="btn btn-primary text-white px-5 py-2">
                        Enviar
                    </button>
                    <button className="btn btn-outline-primary text-primary px-5 py-2 ms-4" onClick={() => setShowConfirmationModal(false)} >
                        Revisar Respostas
                    </button>
                </Modal.Footer>
            </Modal>

            <div className={`fade-in w-100`} style={{ marginBottom: '100px' }}>
                <Link onClick={() => navigate(-1)} className="btn text-primary link border-0 fs-6 mt-3 mt-md-0"><i className="bi bi-chevron-left"></i>Voltar</Link>

                {infoModulo && (
                    <div className="alert alert-info mb-4">
                        <h5 className="alert-heading">Avaliação de Reação</h5>
                        <p className="mb-0">Módulo: <strong>{infoModulo.nome}</strong></p>
                    </div>
                )}
                
                <div className="mb-4">
                    <div className="card">
                        <div className="card-header bg-primary text-white">
                            <h5 className="mb-0">Escala: utilize a escala abaixo para responder</h5>
                        </div>
                        <div className="card-body p-0">
                            <table className="table table-bordered mb-0">
                                <thead>
                                    <tr>
                                        <th className="text-center">1 = Insatisfatório</th>
                                        <th className="text-center">2 = Regular</th>
                                        <th className="text-center">3 = Satisfatório</th>
                                        <th className="text-center">4 = Muito Bom</th>
                                        <th className="text-center">5 = Excelente</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                </div>

                <div className={`${enviarAvaliacao && 'd-none'}`}>
                    <section className="col-12">
                        <div className="card shadow-sm mb-4">
                            <div className="card-header bg-primary text-white py-3">
                                <h4 className="m-0 text-center">Avaliação de Reação - Questão {indiceAtual + 1}/{dataPerguntas.length}</h4>
                            </div>
                            <div className="card-body p-4">
                                {perguntaAtual && (
                                    <div>
                                        <p className="fs-5 mb-4 fw-bold">{perguntaAtual.questao}</p>
                                        <hr className='my-4' />
                                        
                                        {perguntaAtual.tipo === 'escala' ? (
                                            <div className="row mb-4">
                                                {[1, 2, 3, 4, 5].map((valor) => (
                                                    <div className="col text-center" key={valor}>
                                                        <div className="form-check d-flex flex-column align-items-center">
                                                            <input
                                                                className="form-check-input mx-auto"
                                                                type="radio"
                                                                name={`pergunta-${perguntaAtual.id}`}
                                                                id={`alternativa-${perguntaAtual.id}-${valor}`}
                                                                value={valor}
                                                                checked={respostas[perguntaAtual.id] === valor}
                                                                onChange={() => handleSelecao(perguntaAtual.id, valor)}
                                                                style={{ width: '1.5em', height: '1.5em' }}
                                                            />
                                                            <label className="form-check-label mt-2 fw-bold" htmlFor={`alternativa-${perguntaAtual.id}-${valor}`}>
                                                                {valor}
                                                            </label>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : perguntaAtual.tipo === 'sim_nao' ? (
                                            <div className="row justify-content-center mb-4">
                                                <div className="col-md-6">
                                                    <div className="row">
                                                        <div className="col text-center">
                                                            <div className="form-check d-flex flex-column align-items-center">
                                                                <input
                                                                    className="form-check-input mx-auto"
                                                                    type="radio"
                                                                    name={`pergunta-${perguntaAtual.id}`}
                                                                    id={`alternativa-${perguntaAtual.id}-sim`}
                                                                    checked={respostas[perguntaAtual.id] === true}
                                                                    onChange={() => handleSimNao(perguntaAtual.id, true)}
                                                                    style={{ width: '1.5em', height: '1.5em' }}
                                                                />
                                                                <label className="form-check-label mt-2 fw-bold" htmlFor={`alternativa-${perguntaAtual.id}-sim`}>
                                                                    Sim
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="col text-center">
                                                            <div className="form-check d-flex flex-column align-items-center">
                                                                <input
                                                                    className="form-check-input mx-auto"
                                                                    type="radio"
                                                                    name={`pergunta-${perguntaAtual.id}`}
                                                                    id={`alternativa-${perguntaAtual.id}-nao`}
                                                                    checked={respostas[perguntaAtual.id] === false}
                                                                    onChange={() => handleSimNao(perguntaAtual.id, false)}
                                                                    style={{ width: '1.5em', height: '1.5em' }}
                                                                />
                                                                <label className="form-check-label mt-2 fw-bold" htmlFor={`alternativa-${perguntaAtual.id}-nao`}>
                                                                    Não
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null}

                                        <div className="d-flex flex-column flex-md-row justify-content-md-between mt-4 pt-3">
                                            {indiceAtual > 0 ? (
                                                <button onClick={perguntaAnterior} className="btn btn-outline-primary px-4 py-2 mb-2 mb-md-0">
                                                    <i className="bi bi-arrow-left me-2"></i>Questão Anterior
                                                </button>
                                            ) : (
                                                <div></div>
                                            )}
                                            
                                            <button 
                                                onClick={proximaPergunta} 
                                                className={`btn ${indiceAtual === dataPerguntas.length - 1 ? 'btn-success' : 'btn-primary'} text-white px-4 py-2`}
                                            >
                                                {indiceAtual === dataPerguntas.length - 1 ? 'Finalizar' : 'Próxima Questão'}
                                                {indiceAtual !== dataPerguntas.length - 1 && <i className="bi bi-arrow-right ms-2"></i>}
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </section>
                </div>

                <div className={`d-flex justify-content-center align-items-center ${!enviarAvaliacao && 'd-none'}`} style={{ marginTop: '60px' }}>
                    <section className="col-12 col-lg-12 col-xl-8">
                        <div className="d-flex justify-content-center align-items-center bg-primary text-white p-3 rounded-top-4 mt-2">
                            <h4 className="m-0 mt-2">Avaliação de Reação concluída!</h4>
                        </div>
                        <div className="d-flex flex-column justify-content-center align-items-center p-4 bg-white rounded-bottom-4 shadow-sm">
                            <div className="success-icon">
                                <i className="bi bi-check-circle-fill" style={{ fontSize: '5rem', color: '#28a745' }}></i>
                            </div>
                            <h3 className="mt-4 text-center">Obrigado por sua avaliação!</h3>
                            <p className="text-center my-3">
                                Seu certificado está sendo gerado e ficará disponível na área "Certificados".
                            </p>
                            {nivel === 'Aluno' && (
                                <div className="d-flex justify-content-center mt-4">
                                    <button onClick={() => navigate('/aluno/certificado')} className="btn btn-primary text-white px-4 py-2">
                                        Ver Certificados
                                    </button>
                                </div>
                            )}
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
}

export default QuestionarioReacao; 